module.exports = __webpack_public_path__ + "static/suvorov-avatar-6447564852e3fc840fd9f77ab3aeb434.png";